namespace $.$$ {
	export class $shm_hitalama_components_launch extends $.$shm_hitalama_components_launch {
		title() { return this.definition().display_name() }
		edit_arg() { return { section: 'applications', component: this.definition().class_name(), application_run: null } }
	}
}
